module.exports = __webpack_public_path__ + "img/dr.bff0e201.png";